import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";

import {
  fetchOpcionesRespuestaThunk,
  updateOpcionRespuestaThunk,
} from "../../store/preguntasTalento/preguntasTalento.thunks";

import Alert from "../UI/Alert";
import Loader from "../UI/Loader";

const OpcionesRespuestaLayer = () => {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.preguntasTalento.opciones);

  const [draft, setDraft] = useState({});
  const [saving, setSaving] = useState(null);

  useEffect(() => { dispatch(fetchOpcionesRespuestaThunk()); }, [dispatch]);

  useEffect(() => {
    const next = {};
    items.forEach((o) => { next[o.id] = o.texto; });
    setDraft(next);
  }, [items]);

  const save = async (id) => {
    setSaving(id);
    await dispatch(updateOpcionRespuestaThunk({ id, payload: { texto: draft[id] } }));
    setSaving(null);
  };

  const sorted = [...items].sort((a, b) => Number(b.valor) - Number(a.valor));

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <div className="mb-3 d-flex align-items-center gap-2">
          <Icon icon="mdi:toggle-switch-outline" width="22" />
          <h5 className="mb-0 fw-semibold">Opciones Sí / No (globales)</h5>
        </div>
        <p className="text-secondary-light mb-4">
          Texto editable de las dos opciones que verán los estudiantes al responder. No se pueden crear ni eliminar.
        </p>

        {error && <Alert message={String(error)} variant="error" />}

        {loading ? (
          <Loader center text="Cargando opciones..." delay={200} />
        ) : (
          <div className="row g-3">
            {sorted.map((o) => (
              <div key={o.id} className="col-12 col-md-6">
                <div className="border rounded p-3 h-100">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Icon
                      icon={o.valor ? "mdi:check-circle-outline" : "mdi:close-circle-outline"}
                      width="22"
                      className={o.valor ? "text-success-main" : "text-danger-main"}
                    />
                    <span className="fw-semibold">
                      Opción {o.valor ? "afirmativa" : "negativa"} ({o.valor ? "True" : "False"})
                    </span>
                  </div>
                  <label className="form-label fw-medium">Texto</label>
                  <input
                    type="text"
                    className="form-control mb-2"
                    maxLength={100}
                    value={draft[o.id] ?? ""}
                    onChange={(e) => setDraft({ ...draft, [o.id]: e.target.value })}
                  />
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    disabled={saving === o.id || draft[o.id] === o.texto}
                    onClick={() => save(o.id)}
                  >
                    {saving === o.id ? "Guardando..." : "Guardar"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OpcionesRespuestaLayer;
